import { useEffect, useRef } from 'react';
export function DocumentTitle({
  title
}) {
  const initialTitle = useRef(document.title);
  document.title = title;
  useEffect(() => {
    const initialTitleValue = initialTitle.current;
    return () => {
      document.title = initialTitleValue;
    };
  }, [title]);
  return null;
}